import axios from "axios";

export default axios.create({
  baseURL: 'https://saverasia.com/wp-json/api/v2'
  // baseURL: "https://saverasia.360southclients.com/wp-json/api/v2",
});
